// extracted by mini-css-extract-plugin
module.exports = {"Info":"contactsInfo_Info__1P37m","InfoBaltex":"contactsInfo_InfoBaltex__pqtil"};